import BaseFormItem from "../BaseFormItem";
import React from "react";
import Control from "lib/common/descriptorcontrols/DateField/calendar";

export class DateFieldcalendar extends BaseFormItem {
    render() {
        const {activeRecord, descriptor} = this.props;
        return <Control {...this.getPlumbingProps()}
                        value={activeRecord.get(descriptor.key)}
                        enabled={activeRecord.isFieldEnabled(descriptor.key)}
        />;
    }
}

export default DateFieldcalendar;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/DateField/calendar.js